import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateReceptBooking } from 'repositories/BerthApi/updateReceptBooking'
import { berthKeys, bookingKeys } from 'repositories/queryKeys'

export function useUpdateReceptBooking() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateReceptBooking,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.unassigned() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.details() })
    },
  })
}
